export default "__VITE_ASSET__BvuK8RC4__"